"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconHouse = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconHouse = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M17.571 9.1h2.42V6.68h-2.42V9.1Zm0 4.25h2.42v-2.42h-2.42v2.42Zm0 4.25h2.42v-2.42h-2.42v2.42Zm-.615 3.865v-2.15h4.55V4.965h-9.108v1.769l-2.15-1.535V2.815h13.408v18.65h-6.7Zm-15.95 0v-10.35l7.25-5.185 7.25 5.185v10.35h-5.99v-5.55h-2.52v5.55h-5.99Zm2.15-2.15h2.09v-5.15h6.02v5.15h2.09v-7.1l-5.1-3.581-5.1 3.581v7.1Z"
}));
exports.IconHouse = IconHouse;
//# sourceMappingURL=IconHouse.js.map